module.exports = __webpack_public_path__ + "static/og_share-3438691f7a3b2ba13b8e53881fa52bf2.jpg";